export const OrderStatus = {
	CREATED: "CREATED",
	SUBMITTED_FOR_ASSEMBLY: "SUBMITTED_FOR_ASSEMBLY",
	ASSEMBLY_STARTED: "ASSEMBLY_STARTED",
	ASSEMBLY_FINISHED: "ASSEMBLY_FINISHED",
	ON_A_WAY: "ON_A_WAY",
	DELIVERED: "DELIVERED",
	UNDELIVERED: "UNDELIVERED",
	// ARCHIVED: "ARCHIVED",
};
